import { apiV3Client } from './BaseRepository';

export function fetchJobUsageBudget(jobId) {
  return apiV3Client.get(`budget-capping/${jobId}/available-budget`);
}
export function fetchAllJobUsageBudgetRequests(payload, pageSize = 10, pageNumber = 1) {
  return apiV3Client.post(`budget-capping/requests`, {
    From: (pageNumber - 1) * pageSize,
    Size: pageSize,
    ...payload,
  });
}

export function postBudgetCappingRequest(jobId, totalBudget) {
  return apiV3Client.post(`budget-capping/request`, {
    BudgetUnits: totalBudget,
    JobId: jobId,
  });
}

export function updateBudgetRequestStatus(requestId, payload) {
  return apiV3Client.put(`budget-capping/request/${requestId}`, payload);
}

// Scopes ("User" | "Job") the current user may approve in their own org.
// Empty => not an approver; used to gate the approve UI.
export function fetchMyApproverScopes() {
  return apiV3Client.get(`budget-capping/approvers/me`);
}

export function fetchUserBudget() {
  return apiV3Client.get(`budget-capping/available-budget`);
}

export function fetchAllUserBudgetRequests(payload, pageSize = 10, pageNumber = 1) {
  return apiV3Client.post(`budget-capping/requests/user`, {
    From: (pageNumber - 1) * pageSize,
    Size: pageSize,
    ...payload,
  });
}
